import { ButtonGroup } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import React, { Dispatch, FC, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { Button, Stack, Typography } from "@components/base";

interface Component {
  page: number;
  pages: number;
  setPage: Dispatch<SetStateAction<number>>;
}

const Component: FC<Component> = ({ page, pages, setPage }) => {
  const { t } = useTranslation();

  const handleNextPage = (): void => {
    setPage(page + 1);
  };

  const handlePrevPage = (): void => {
    setPage(page - 1);
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-end">
      <Typography color="textSecondary">
        {t("pagination.pageInfo", { current: page + 1, total: pages })}
      </Typography>
      <ButtonGroup>
        <Button
          variant="contained"
          size="small"
          disabled={page === 0}
          onClick={handlePrevPage}
        >
          <FeatherIcon icon="chevron-left" size={16} />
        </Button>
        <Button
          variant="contained"
          size="small"
          disabled={page + 1 === pages}
          onClick={handleNextPage}
        >
          <FeatherIcon icon="chevron-right" size={16} />
        </Button>
      </ButtonGroup>
    </Stack>
  );
};

export default Component;
